import { render } from "./NotificationHistoryModal.vue?vue&type=template&id=52065f42&scoped=true"
import script from "./NotificationHistoryModal.vue?vue&type=script&lang=js"
export * from "./NotificationHistoryModal.vue?vue&type=script&lang=js"

import "./NotificationHistoryModal.vue?vue&type=style&index=0&id=52065f42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52065f42"]])

export default __exports__